import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/balanced.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await resetPassword(email);
      setEmailSent(true);
    } catch (err) {
      const errorMessage = err.message || '';
      if (errorMessage.includes('rate limit') || errorMessage.includes('429')) {
        setError('Too many requests. Please wait a few minutes before trying again.');
      } else {
        setError(err.message || 'Failed to send reset email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--light-gray)' }}>
        <div style={{ width: '100%', maxWidth: '500px', padding: '2rem' }}>
          <div className="card-emphasis">
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <div style={{
                width: '80px',
                height: '80px',
                background: '#d1fae5',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem'
              }}>
                <span style={{ fontSize: '2.5rem' }}>📧</span>
              </div>
              <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '1rem' }}>Check Your Email</h1>
              <p style={{ color: 'var(--gray)', lineHeight: '1.6' }}>
                We've sent a password reset link to <strong>{email}</strong>
              </p>
            </div>

            <div style={{ background: 'var(--light-gray)', padding: '1rem', borderRadius: '0.5rem', marginBottom: '1.5rem' }}>
              <p style={{ fontSize: '0.875rem', color: 'var(--charcoal)', marginBottom: '0.5rem' }}>
                <strong>What's next?</strong>
              </p>
              <ol style={{ fontSize: '0.875rem', color: 'var(--charcoal)', paddingLeft: '1.25rem', marginBottom: 0 }}>
                <li>Check your inbox (and spam folder)</li>
                <li>Click the password reset link</li>
                <li>Set your new password</li>
              </ol>
            </div>

            <Link to="/login" className="btn btn-primary" style={{ width: '100%', textAlign: 'center', display: 'block' }}>
              Back to Sign In
            </Link>

            <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.875rem', color: 'var(--gray)' }}>
              Didn't receive the email?{' '}
              <button
                onClick={() => {
                  setEmailSent(false);
                  setError('');
                }}
                style={{ background: 'none', border: 'none', color: 'var(--gold)', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }}
              >
                Try again
              </button>
            </p>
          </div>

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <Link to="/" style={{ color: 'var(--gray)', fontSize: '0.875rem', textDecoration: 'none' }}>
              ← Back to website
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--light-gray)' }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '2rem' }}>
        <div className="card-emphasis">
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <img
              src="/fNew_logo_2.png"
              alt="IDNTY Logo"
              style={{ height: '70px', width: 'auto', marginBottom: '0.5rem' }}
            />
            <h1 style={{ fontSize: '1.5rem', fontWeight: 700, marginBottom: '0.5rem' }}>Forgot Password?</h1>
            <p style={{ color: 'var(--gray)', fontSize: '0.9rem' }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
          </div>

          {error && (
            <div style={{ background: '#fee2e2', color: '#991b1b', padding: '0.75rem', borderRadius: '0.5rem', marginBottom: '1rem', fontSize: '0.875rem' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label className="form-label">Email Address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input"
                placeholder="you@company.com"
                autoFocus
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
              style={{ width: '100%', marginBottom: '1rem' }}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <p style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--gray)' }}>
              Remember your password?{' '}
              <Link to="/login" style={{ color: 'var(--gold)', fontWeight: 600, textDecoration: 'none' }}>
                Sign in
              </Link>
            </p>
          </form>
        </div>

        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <Link to="/" style={{ color: 'var(--gray)', fontSize: '0.875rem', textDecoration: 'none' }}>
            ← Back to website
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
